import { jsx as _jsx } from "react/jsx-runtime";
// import components
import Paper from "@mui/material/Paper";
export const PaperAtomComponent = (props) => _jsx(Paper, { "data-testid": "Paper", ...props });
export default PaperAtomComponent;
